<template>
  <page-column>
    <Header :lang="lang" from="product" @changeLanuage="changeLanuage"></Header>
    <div>
      <div class="banner-c"><img :src="bannerImage"></div>
    </div>
    <div class="bread-c">
      <div class="left-c">
        <div class="title" v-if="!isShowProduct" style="    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 5rem;">
          <template>{{ detailCompanyInfo.title }}</template>
        </div>
        <div class="title" v-if="isShowProduct" style="    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 5rem;">
          <template>{{ detailContent.productName }}</template>
          <!-- <span style="font-size: 16px;color: #999;font-weight: 100;margin-left: 10px;">Detail content</span> -->
        </div>
        <!-- <div v-if="lang == 'zh'" style="display: flex;">
          <div @click="$router.push('/' + lang)" style="cursor: pointer;">首页</div>
          <div style="cursor: pointer"> >{{ company.companyName }}</div>
        </div>
        <div v-if="lang == 'en'" style="display: flex;">
          <div @click="$router.push('/' + lang)" style="cursor: pointer;">Home Page </div>
          <div style="cursor: pointer"> >{{ company.enCompanyName }}</div>
        </div>
        <div v-if="lang == 'ja'" style="display: flex;">
          <div @click="$router.push('/' + lang)" style="cursor: pointer;">最初のページ</div>
          <div style="cursor: pointer"> >{{ company.jaCompanyName }}</div>
        </div> -->
      </div>
      <div class="product-c" @click="showProduct()">
        <span v-if="lang==='zh'">产品中心</span>
        <span v-if="lang==='en'">Product</span>
        <span v-if="lang==='ja'">製品</span>
      </div>
    </div>
    <div class="product-right-c" :style="'background:' + rightBlockColor">
      <div style="display: flex;flex-direction: row;justify-content: space-between;">
        <div v-if="!isShowProduct" class="book-c">
          <div class="book-c-wrapper">
            <div v-for="(item, index) in zhuanLiList" :key="index" @click="getBookDetail(item)">
              <img :src="item.icoList[0].url" :style="getStyle(item)">
            </div>
          </div>
        </div>
      </div>

      <div v-if="!isShowProduct" style="line-height: 30px;" v-html="detailCompanyInfo.content">

      </div>
      <div style="text-align: center;min-height: 700px;" v-show="isShowProduct">
        <div v-html="detailContent.detail"></div>
      </div>
    </div>

    <Popup v-model="show" position="left">
      <div class="tree-c">
        <el-tree :data="categoryList" :props="defaultProps" @node-click="handleNodeClick"></el-tree>
      </div>
    </Popup>
  </page-column>
</template>
<script>
import Header from '../components/mobile/header.vue'
import { Popup } from 'vant';
export default {
  name: 'Products',
  props: {
    lang: {}
  },
  components: {
    Header,
    Popup
  },
  data() {
    return {
      bannerImage: '',
      company: {},
      bgColor: '',
      leftBlockColor: '',
      rightBlockColor: '',
      imageConfig: {},
      show: false,
      categoryList: [],
      defaultProps: {
        tree: 'tree',
        label: 'label'
      },
      isShowProduct: false,
      zhuanLiList: [],
      detailContent: {},
      detailCompanyInfo: {},
    
    }

  },
  watch: {
    "$route": "fetchData",
  },
  mounted() {
    this.fetchData()
    this.getCompanyIcoImage()
    // this.getDetailContent();
    
  },
  methods: {
    fetchData() {
      console.log('jjj',this.lang)
      if (this.$route.query.productId) {
        this.isShowProduct = true
        this.getProductDetail({ id: this.$route.query.productId })
      } else {

      }
      this.getCompanyDetail()
      this.fechTreeData()
      this.getCompanyInfo()
    },
    showProduct() {
      this.show = !this.show
    },
    goCurrentHome() { },
    handleNodeClick(data) {
      console.log(data);
      if (data.children.length === 0) {
        this.getProductDetail(data)
      }
    },
    changeLanuage(){
      this.$route.query.productId = ''
      this.isShowProduct = false
      this.fetchData()
    },
    getStyle(item) {
      return 'width:' + item.icoSize + 'px'
    },
    async getProductDetail(item) {
      console.log(this.$route.query)
      // const newQuery = Object.assign(this.$route.query,{productId:item.id})
      this.$router.push({ query: { ...this.$route.query, productId: item.id } })
      const res = await this.$http.post(`/getNewproduct`, { id: item.id, la: this.lang })
      this.detailContent = res.data[0] || { detail: '暂无', productName: '请配置' }
      this.isShowProduct = true
      this.show = false
    },
    async fechTreeData() {
      const res = await this.$http.get(`/category/${this.$route.query.id}`)
      const treeObj = res.data.find(v => {
        if (v.language === this.lang) {
          return v
        }
      })
      this.categoryList = treeObj ? treeObj.tree : []
    },
    async getCompanyDetail() {
      const res = await this.$http.get(`/company/${this.$route.query.id}`)
      this.company = res.data
      this.bannerImage = res.data.companyBannerList[0].url
      this.bgColor = res.data.companyBdColor
      this.leftBlockColor = res.data.companyBlock1Color
      this.rightBlockColor = res.data.companyDetailColor
    },
    async getCompanyIcoImage() {//专利图标及大图
      const res = await this.$http.post(`/companyPatent`, { id: this.$route.query.id, la: this.currentLanguage })
      this.zhuanLiList = res.data[0] && res.data[0].contentList || []
      console.log(res.data)
      console.log(this.zhuanLiList)
    },
    async getImage() {
      const res = await this.$http.get('imageConfig')
      this.imageConfig = res.data[0] || {}
    },
    async getCompanyInfo() {
      //   const res  =  await this.$http.post('companyInfoList',{la:this.lang,type:0})
      const res = await this.$http.get(`/companyInfo/${this.$route.query.id}`)
      this.detailCompanyInfo = res.data.find(v => v.language === this.lang)
    },
  }
}
</script>
<style lang="scss" scoped>
.banner-c {
  height: 6.6rem;

  img {
    margin: 0 auto;
    position: absolute;
    left: 0;
    width: 100%;
  }

}

.bread-c {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: .26rem .32rem;
  box-sizing: border-box;
  border-bottom: .02rem solid rgba(0, 0, 0, 0.08);

  .left-c {
    font-size: .28rem;
    color: #666;
  }

  .product-c {
    font-size: .28rem;
    color: #666;
  }
}

.product-right-c {
  padding: .26rem .32rem;
  box-sizing: border-box;
}

.tree-c {
  height: 100vh;
  width: 5rem;
  padding: 0.26rem;
}</style>